import * as Yup from "yup";
const ACCEPTED_IMAGE_TYPES = ["image/jpeg", "image/png"];

/**
 * @description for validation of data
 * @returns Schemas for Validation
 */

import {
  emailRegExp,
  passRegrex,
  passwordError,
  phoneRegExp,
} from "./validation";
import {
  ACCEPTED_TYPES,
  ARTICLE_FIELD_LIMITS,
  ARTICLE_STATUS_OPTIONS,
  EMAIL_STATUS,
  MAX_FILE_SIZE_BYTES,
  MAX_FILE_SIZE_MB,
  ARTICLE_STATUS,
} from "./contentTypes";

export const LoginSchema = () =>
  Yup.object().shape({
    email: Yup.string()
      .trim()
      .required("Enter the required field")
      .matches(emailRegExp, "Please enter valid Email"),
    password: Yup.string()
      .trim()
      .required("Enter the required field")
      .max(16, "Password should be maximum of 16 characters")
      .min(8, "Password should be minimum of 8 characters")
      .matches(passRegrex, passwordError),
  });

export const ResetPasswordSchema = () =>
  Yup.object().shape({
    email: Yup.string()
      .trim()
      .required("Enter the required field")
      .matches(emailRegExp, "Please enter valid Email"),
  });

export const ChangePasswordSchema = () =>
  Yup.object().shape({
    oldPassword: Yup.string()
      .trim()
      .required("Enter the required field")
      .max(16, "Password should be maximum of 16 characters")
      .min(8, "Password should be minimum of 8 characters")
      .matches(passRegrex, passwordError),
    newPassword: Yup.string()
      .trim()
      .required("Enter the required field")
      .max(16, "Password should be maximum of 16 characters")
      .min(8, "Password should be minimum of 8 characters")
      .matches(passRegrex, passwordError),
    confirmPassword: Yup.string()
      .trim()
      .required("Enter the required field")
      .oneOf(
        [Yup.ref("newPassword"), null],
        "Confirm password and New Password must match",
      ),
  });
export const SetNewPasswordSchema = () =>
  Yup.object().shape({
    newPassword: Yup.string()
      .trim()
      .required("Enter the required field")
      .max(16, "Password should be maximum of 16 characters")
      .min(8, "Password should be minimum of 8 characters")
      .matches(passRegrex, passwordError),
    confirmPassword: Yup.string()
      .trim()
      .required("Enter the required field")
      .oneOf(
        [Yup.ref("newPassword"), null],
        "Confirm password and New Password must match",
      ),
  });

export const EditProfileSchema = () =>
  Yup.object().shape({
    firstName: Yup.string()
      .trim()
      .required("Enter your first name")
      .min(2, "First name should be minimum of 2 characters")
      .max(30, "First name should be maximum of 30 characters"),
    lastName: Yup.string()
      .trim()
      .required("Enter your last name")
      .min(2, "Last name should be minimum of 2 characters")
      .max(30, "Last name should be maximum of 30 characters"),
    phoneNo: Yup.string()
      .trim()
      .required("Enter your phone number")
      .min(10, "Mobile number should be 10 digit")
      .matches(phoneRegExp, "Please enter a valid phone nubmer."),
    // profileImage:Yup.string().trim().required("Enter ")
  });

export const addSitesSchema = () =>
  Yup.object().shape({
    siteName: Yup.string()
      .trim()
      .required("Enter site name")
      .min(2, "Site name should be minimum of 2 characters")
      .max(50, "Site name should be maximum of 30 characters"),
    description: Yup.string()
      .trim()
      .required("Enter site description")
      .min(15, "Site desciption should be minimum of 15 characters")
      .max(2000, "Site desciption should be maximum of 2000 characters"),
    addressLine1: Yup.string()
      .trim()
      .required("Enter site address")
      .min(2, "Site addressLine should be minimum of 2 characters")
      .max(200, "Site addressLine should be maximum of 200 characters"),
    addressLine2: Yup.string()
      .trim()
      .required("Enter alternative site address")
      .min(2, "Site addressLine should be minimum of 2 characters")
      .max(200, "Site addressLine should be maximum of 200 characters"),
    postalCode: Yup.string()
      .trim()
      .required("Enter your postal code")
      .min(4, "Postal code should be 4 characters")
      .max(8, "Postal code should be at max 8 characters"),
    city: Yup.string()
      .trim()
      .required("Enter site city")
      .min(2, "City name should be minimum of 2 characters")
      .max(30, "City name should be maximum of 30 characters"),
    state: Yup.string()
      .trim()
      .required("Enter site state")
      .min(2, "state name should be minimum of 2 characters")
      .max(30, "state name should be maximum of 30 characters"),
    country: Yup.string()
      .trim()
      .required("Enter site country")
      .min(2, "country name should be minimum of 2 characters")
      .max(30, "country name should be maximum of 30 characters"),
    latitude: Yup.number()
      .required("Enter your latitude value")
      .max(90, "Latitude cannot exceed 90")
      .min(-90, "Latitude cannot be less than -90"),
    longitude: Yup.number()
      .required("Enter your longitude value")
      .max(180, "Longitude cannot exceed 180")
      .min(-180, "Longitude cannot be less than -180"),
    diveType: Yup.string().required("Select dive type"),
    maxDepth: Yup.number()
      .required("Enter max depth")
      .min(0, "Max depth cannot be less than 0")
      .max(11000, "Max Depth cannot exceed 11000"),
    // images: Yup.array()
    //   .min(
    //     2,
    //     "At least 2 image and video is required. default image and other site images"
    //   )
    //   .max(20, "At max you can upload 20 images")
    //   .of(
    //     Yup.mixed().test("fileType", "Unsupported file format", (value) =>
    //       ["image/jpeg", "image/png", "image/gif", "video/mp4", "video/quicktime"].includes(
    //         value?.type
    //       )
    //     )
    //   )
    //   .required("Images are required"),
  });

export const updateSitesSchema = () =>
  Yup.object().shape({
    siteName: Yup.string()
      .trim()
      .required("Enter site name")
      .min(2, "Site name should be minimum of 2 characters")
      .max(50, "Site name should be maximum of 30 characters"),
    description: Yup.string()
      .trim()
      .required("Enter site description")
      .min(15, "Site desciption should be minimum of 15 characters")
      .max(2000, "Site desciption should be maximum of 2000 characters"),
    addressLine1: Yup.string()
      .trim()
      .required("Enter site address")
      .min(2, "Site addressLine should be minimum of 2 characters")
      .max(200, "Site addressLine should be maximum of 200 characters"),
    addressLine2: Yup.string()
      .trim()
      .required("Enter alternative site address")
      .min(2, "Site addressLine should be minimum of 2 characters")
      .max(200, "Site addressLine should be maximum of 200 characters"),
    postalCode: Yup.string()
      .trim()
      .required("Enter your postal code")
      .min(4, "Postal code should be 4 digit")
      .max(8, "Postal code should be at max 8 digits"),
    city: Yup.string()
      .trim()
      .required("Enter site city")
      .min(2, "City name should be minimum of 2 characters")
      .max(30, "City name should be maximum of 30 characters"),
    state: Yup.string()
      .trim()
      .required("Enter site state")
      .min(2, "state name should be minimum of 2 characters")
      .max(30, "state name should be maximum of 30 characters"),
    country: Yup.string()
      .trim()
      .required("Enter site country")
      .min(2, "country name should be minimum of 2 characters")
      .max(30, "country name should be maximum of 30 characters"),
    latitude: Yup.number()
      .required("Enter your latitude value")
      .max(90, "Latitude cannot exceed 90")
      .min(-90, "Latitude cannot be less than -90"),
    longitude: Yup.number()
      .required("Enter your longitude value")
      .max(180, "Longitude cannot exceed 180")
      .min(-180, "Longitude cannot be less than -180"),
    diveType: Yup.string().required("Select dive type"),
    maxDepth: Yup.number()
      .required("Enter max depth")
      .min(0, "Max depth cannot be less than 0")
      .max(11000, "Max Depth cannot exceed 11000"),
    // images: Yup.array()
    //   .min(1, "At least one image is required")
    //   .max(20, "At max you can upload 20 images")
    //   .of(
    //     Yup.mixed().test("fileType", "Unsupported file format", (value) =>
    //       ["image/jpeg", "image/png", "image/gif"].includes(value?.type)
    //     )
    //   )
    //   .required("Images are required"),
  });

export const addCitySchema = () =>
  Yup.object().shape({
    postalCode: Yup.string()
      .trim()
      .required("Enter your postal code")
      .min(4, "Postal code should be 4 characters")
      .max(8, "Postal code should be at max 8 characters"),
    city: Yup.string()
      .trim()
      .required("Enter site city")
      .min(2, "City name should be minimum of 2 characters")
      .max(30, "City name should be maximum of 30 characters"),
    state: Yup.string()
      .trim()
      .required("Enter site state")
      .min(2, "state name should be minimum of 2 characters")
      .max(30, "state name should be maximum of 30 characters"),
    country: Yup.string()
      .trim()
      .required("Enter site country")
      .min(2, "country name should be minimum of 2 characters")
      .max(30, "country name should be maximum of 30 characters"),
  });

export const addHowToVideosAddValidationSchema = Yup.object().shape({
  title: Yup.string()
    .trim()
    .required("Tutorial title is required")
    .min(3, "Title must be at least 3 characters")
    .max(120, "Title must be under 120 characters")
    .matches(
      /^(?!.* {2,}).*$/,
      "Title cannot contain multiple consecutive spaces",
    ),
  video: Yup.mixed()
    .required("Tutorial video is required")
    .test(
      "fileType",
      "Please upload a valid video file (MP4, WebM, OGG, MOV).",
      (file) => !file || ACCEPTED_TYPES.includes(file.type),
    )
    .test(
      "fileSize",
      `Video must be smaller than ${MAX_FILE_SIZE_MB}MB.`,
      (file) => !file || file.size <= MAX_FILE_SIZE_BYTES,
    ),
  thumbnail: Yup.mixed()
    .required("Thumbnail image is required")
    .test(
      "fileType",
      "Please upload a valid image file (JPG, PNG).",
      (file) => !file || ACCEPTED_IMAGE_TYPES.includes(file.type),
    )
    .test(
      "fileSize",
      `Thumbnail must be smaller than ${MAX_FILE_SIZE_MB}MB.`,
      (file) => !file || file.size <= MAX_FILE_SIZE_BYTES,
    ),
});
export const editHowToVideosValidationSchema = Yup.object().shape({
  title: Yup.string()
    .trim()
    .required("Tutorial title is required")
    .min(3, "Title must be at least 3 characters")
    .max(120, "Title must be under 120 characters")
    .matches(
      /^(?!.* {2,}).*$/,
      "Title cannot contain multiple consecutive spaces",
    ),

  video: Yup.mixed()
    .nullable()
    .test(
      "required-if-no-existing-video",
      "Please upload a video.",
      function (file) {
        const { existingVideoUrl } = this.parent;

        if (file || existingVideoUrl?.trim()) {
          return true;
        }

        return false;
      },
    )
    .test(
      "fileType",
      "Please upload a valid video file (MP4, WebM, OGG, MOV).",
      (file) => !file || ACCEPTED_TYPES.includes(file.type),
    )
    .test(
      "fileSize",
      `Video must be smaller than ${MAX_FILE_SIZE_MB}MB.`,
      (file) => !file || file.size <= MAX_FILE_SIZE_BYTES,
    ),

  existingVideoUrl: Yup.string().nullable(),

  thumbnail: Yup.mixed()
    .nullable()
    .test(
      "required-if-no-existing-thumbnail",
      "Please upload a thumbnail image.",
      function (file) {
        const { existingThumbnailUrl } = this.parent;

        if (file || existingThumbnailUrl?.trim()) {
          return true;
        }

        return false;
      },
    )
    .test(
      "fileType",
      "Please upload a valid image file (JPG, PNG).",
      (file) => !file || ACCEPTED_IMAGE_TYPES.includes(file.type),
    )
    .test(
      "fileSize",
      `Thumbnail must be smaller than ${MAX_FILE_SIZE_MB}MB.`,
      (file) => !file || file.size <= MAX_FILE_SIZE_BYTES,
    ),

  existingThumbnailUrl: Yup.string().nullable(),
});

export const emailTemplateValidationSchema = Yup.object().shape({
  subject: Yup.string()
    .trim()
    .required("Subject is required")
    .max(150, "Subject must be under 150 characters"),
  status: Yup.string()
    .oneOf([...Object.values(EMAIL_STATUS)], "Invalid status")
    .required("Status is required"),
  html: Yup.string().trim().required("Email content cannot be empty"),
});

export const AddEditArticleSchema = (bannerPreview) =>
  Yup.object().shape({
    title: Yup.string()
      .trim()
      .required("Enter the required field")
      .min(5, "Title should be minimum of 5 characters")
      .max(
        ARTICLE_FIELD_LIMITS.TITLE_MAX,
        `Title should be maximum of ${ARTICLE_FIELD_LIMITS.TITLE_MAX} characters`,
      ),
    content: Yup.string().trim().required("Enter the required field"),
    banner: bannerPreview
      ? Yup.mixed().nullable()
      : Yup.mixed().nullable().required("Please upload a banner image"),
    readTime: Yup.number()
      .typeError("Read time must be a number")
      .required("Read time is required")
      .min(1, "Minimum 1 minute")
      .max(
        ARTICLE_FIELD_LIMITS.READ_TIME_MAX,
        `Maximum ${ARTICLE_FIELD_LIMITS.READ_TIME_MAX} minutes`,
      ),
    description: Yup.string()
      .trim()
      .required("Enter the required field")
      .min(10, "Description should be minimum of 10 characters")
      .max(
        ARTICLE_FIELD_LIMITS.DESCRIPTION_MAX,
        `Description should be maximum of ${ARTICLE_FIELD_LIMITS.DESCRIPTION_MAX} characters`,
      ),
    status: Yup.string()
      .oneOf(
        Object.values(ARTICLE_STATUS).map(String), // ["1", "2"]
        "Status must be either draft or published",
      )
      .required("Status is required"),
    tags: Yup.array()
      .of(
        Yup.string()
          .trim()
          .max(
            ARTICLE_FIELD_LIMITS.TAG_MAX_LENGTH,
            `Each tag must be at most ${ARTICLE_FIELD_LIMITS.TAG_MAX_LENGTH} characters`,
          ),
      )
      .max(
        ARTICLE_FIELD_LIMITS.TAGS_MAX_COUNT,
        `Maximum ${ARTICLE_FIELD_LIMITS.TAGS_MAX_COUNT} tags allowed`,
      ),
  });
